var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFitronLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 79,
    viewBox: "0 0 110 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.3222 27.643V37.4654H7.71221V39.2895H2.3222V53.3215H-0.230957V25.8188H8.13773V27.643H2.3222Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3574 53.3215V25.8188H19.9106V53.3215H17.3574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5206 27.643V53.3215H31.9675V27.643H28.9888V25.8188H37.6411V27.643H34.5206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6832 25.8188C54.3782 25.8188 55.513 26.3801 55.513 28.9059V35.9219C55.513 37.3251 54.9456 38.4476 53.3853 38.7283C55.2293 39.0089 55.6548 40.2718 55.6548 41.675V53.3215H53.2435V41.5347C53.2435 40.1315 52.818 39.7105 51.8251 39.7105H49.2719V53.3215H46.7188V25.8188H51.6832ZM49.2719 37.8863H51.6832C52.6761 37.8863 53.1016 37.3251 53.1016 36.0622V29.4672C53.1016 28.064 52.6761 27.643 51.5414 27.643H49.2719V37.8863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.002 53.1811L103.03 32.4138V53.1811H100.477V25.6785H103.456L107.427 46.4458V25.6785H109.98V53.1811H107.002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7814 51.7585L59.583 78.6999H62.1362L73.909 52.6005C73.1998 52.4601 72.4906 52.1795 71.7814 51.7585Z",
    fill: "#E40031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4916 24.8364C70.4066 24.8364 63.8818 31.2911 63.8818 39.2894C63.8818 47.2876 70.4066 53.7423 78.4916 53.7423C86.5766 53.7423 93.1013 47.2876 93.1013 39.2894C93.1013 31.2911 86.5766 24.8364 78.4916 24.8364ZM78.4916 47.2876C74.0945 47.2876 70.4066 43.7796 70.4066 39.2894C70.4066 34.9395 73.9526 31.2911 78.4916 31.2911C82.8887 31.2911 86.5766 34.7991 86.5766 39.2894C86.5766 43.6393 83.0305 47.2876 78.4916 47.2876Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8106 0L74.52 46.1652C75.2292 46.5861 75.9384 46.8668 76.6477 47.0071L96.3637 0H93.8106Z",
    fill: "#E40031"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 79,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitronLogo);
export default __webpack_public_path__ + "static/media/fitron-logo.8b4c35c9ce09d77c09bc00805e6ad84a.svg";
export { ForwardRef as ReactComponent };